import React, { PureComponent } from "react";
import {
  Metric,
  selectFormat,
  getCountryFlag,
  MAIN_COLORS,
  Error,
} from "components/Utils/Utils.js";
import clsx from "clsx";
import Heading from "components/Elements/Heading";
// import { Link } from "react-router-dom";

import { BarChart, Bar, Cell } from "recharts";

class WorldCupActualRatings extends PureComponent {
  render() {
    const { data, title } = this.props;

    if (data.hasData === false) {
      return <Error minHeight={260} />;
    }

    const renderMetrics = () =>
      data.chart
        .filter((item) => item.name === "Platforms Current")
        .map((item, i) => {
          const key = Object.entries(item)[1];
          const value = key[1];
          return (
            <div key={i} className="mb-2">
              <div className="d-flex info-detail-list align-items-center ">
                <div
                  className="info-detail-icon"
                  style={{ backgroundColor: MAIN_COLORS[i] }}
                ></div>
                <div className="mr-auto info-detail info-detail-label">
                  {key}
                </div>
                <div className="mr-auto">
                  <Metric value={value} size={"xs"} />
                </div>
              </div>
            </div>
          );
        });

    const renderBars = (data) => {
      let bars = [];
      let all_bars = [];

      for (let i = 0; i <= data.length - 1; i++) {
        Object.keys(data[i]).forEach((bar, key) => {
          if (bar !== "name") {
            all_bars.push(bar);
          }
        });
      }

      all_bars.forEach((bar, i) => {
        bars.push(
          <Bar key={i} dataKey={bar} stackId="stack" barSize={40}>
            <Cell fill={MAIN_COLORS[i]} />
          </Bar>
        );
      });

      return bars;
    };

    const COLORS = ["orange", "teal", "yellow"];

    const renderColumns = (results, meta) =>
      results.map((result, index) => (
        <div className="mt-4 mb-4 d-inline-block width-300" key={index}>
          <div className="mx-2 d-flex">
            {result.chart && (
              <div
                className={clsx("progress-bar-lg cell-chart", {
                  progress: result.chart !== "0%",
                  "progress-no-value": result.chart === "0%",
                })}
              >
                <div
                  className={`progress-bar progress-bar-${COLORS[index]}`}
                  role="progressbar"
                  style={{
                    width: result.chart,
                  }}
                  aria-valuenow={result.chart}
                  aria-valuemin="0"
                  aria-valuemax="100"
                ></div>
              </div>
            )}

            {result.metric.value > 0 && (
              <div className="ml-2 d-flex justify-content-center align-items-center world-cup-primary-metric-gray">
                {result.metric && (
                  <Metric
                    size={"xs"}
                    value={result.metric.value}
                    format="0,0"
                  />
                )}
              </div>
            )}
          </div>

          <div className="mx-2 mt-4 d-flex align-items-center height-70">
            {result.metric_secondary && (
              <span className="mr-2 ratings-circle">
                <Metric
                  size={"xxs"}
                  value={result.metric_secondary.value}
                  format={"%"}
                />
              </span>
            )}
            {result.metric_secondary_name && (
              <span className="mr-2 info-detail">
                {result.metric_secondary_name}
              </span>
            )}
            <div>
              {result.metric_tertiary_name && (
                <p className="mb-1 info-detail">
                  {result.metric_tertiary_name}
                </p>
              )}
              {result.chart_secondary && (
                <>
                  <div className="progress progress-bar-sm cell-chart progress-bar-bg-yellow">
                    <div
                      className="progress-bar progress-bar-teal"
                      role="progressbar"
                      style={{
                        width: result.chart_secondary,
                      }}
                      aria-valuenow={result.chart_secondary}
                      aria-valuemin="0"
                      aria-valuemax="100"
                    ></div>
                  </div>

                  <div className="progress-bar-label d-flex justify-content-between">
                    <img
                      src={`https://d1fh34r1lqg2ii.cloudfront.net/logos/telemundo.svg`}
                      alt="Telemundo"
                      className="mt-1 channel-logo--xs"
                    />

                    <img
                      src={`https://d1fh34r1lqg2ii.cloudfront.net/logos/${meta.network}.svg`}
                      alt={`${meta.network}`}
                      className="mt-1 channel-logo--xs"
                    />
                  </div>
                </>
              )}

              {result.metric_pregame && result.metric_gametime && (
                <div className="d-flex">
                  <div>
                    <span className="world-cup-tag world-cup-tag--gray">
                      Pre-Game
                    </span>

                    {result.metric_pregame.value > 0 && (
                      <div className="mt-1">
                        <Metric
                          size={"xxs"}
                          value={result.metric_pregame.value}
                          format={"0,0"}
                        />
                      </div>
                    )}
                  </div>

                  <div>
                    <span className="world-cup-tag world-cup-tag--teal">
                      Gametime
                    </span>

                    {result.metric_gametime.value > 0 && (
                      <div className="mt-1">
                        <Metric
                          size={"xxs"}
                          value={result.metric_gametime.value}
                          format={"0,0"}
                        />
                      </div>
                    )}
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      ));

    const renderRows = () =>
      data.matches.map((match, i) => (
        <div key={i}>
          <div className="d-inline-flex">
            <div className="mt-4 d-inline-block width-300">
              <div className="mb-1 info-heading">
                <span className="mr-1 world-cup-country-flag-icon">
                  {getCountryFlag(match.meta.teams[0].country)}
                </span>
                {match.meta.teams[0].team} vs{" "}
                <span className="mr-1 world-cup-country-flag-icon">
                  {getCountryFlag(match.meta.teams[1].country)}{" "}
                </span>
                {match.meta.teams[1].team}
              </div>
              <div className="mb-1 info-detail">
                Air Time:{" "}
                <span className="info-value">{match.meta.air_time}</span>
              </div>
              <div>
                <span className="info-detail">
                  Match: <span className="info-value">{match.meta.match}</span>
                </span>
                <span className="ml-2 info-detail">
                  Stage: <span className="info-value">{match.meta.stage}</span>
                </span>
              </div>

              {/* <img
                src={`https://d1fh34r1lqg2ii.cloudfront.net/logos/${match.meta.network}.svg`}
                alt={`${match.meta.network}`}
                className="mt-2 channel-logo"
              /> */}
            </div>

            {renderColumns(match.results, match.meta)}
          </div>

          {i < data.matches.length - 1 && (
            <div className="my-2 divider-dotted-spaced"></div>
          )}
        </div>
      ));

    return (
      <>
        <div className="row">
          {title && (
            <div className="mb-4 col-12">
              <small className="info-format">
                All values are in Thousands (000)
              </small>
              {/* <p className="mt-2">
                Showing 3 Most Recent Days. {""}
                <Link
                  to={`${window.location.pathname}/match_actuals`}
                  className="world-cup-see-more"
                >
                  See all matches.
                </Link>
              </p> */}
            </div>
          )}

          <div className="col-12">
            <div className="flex column-header--section">
              Based on Nielsen Actual Data for matches as of {""}
              <span className="column-header">
                {selectFormat("date", data.meta.date, "dddd MMMM Do YYYY")}
              </span>
              <span className="mx-2">|</span>
              <span>
                Match Day:{" "}
                <span className="column-header">{data.meta.match_day}</span>{" "}
                <span className="mx-2">|</span>
              </span>
              <span>
                Games Played:{" "}
                <span className="column-header">{data.meta.games_played}</span>
              </span>
            </div>
          </div>
        </div>

        {data.matches.length > 0 ? (
          <div className="mt-4 overflow-auto">
            <div className="d-inline-flex row-divider-line-bottom">
              <div className="d-inline-block width-300">
                <div className="text-left column-header">Match</div>
              </div>
              <div className="d-inline-block width-300">
                <div className="mx-2 column-header">TAD Persons 2+</div>
              </div>
              <div className="d-inline-block width-300">
                <div className="mx-2 column-header">
                  Telemundo Linear Persons 2+
                </div>
              </div>
              <div className="d-inline-block width-300">
                <div className="mx-2 column-header">Fox Linear Persons 2+</div>
              </div>
            </div>
            {renderRows()}
          </div>
        ) : (
          <div className="mt-5">
            <p className="world-cup-no-matches">
              There is no match data for this day.
            </p>
          </div>
        )}

        {/* <div className="mt-3 row">
          <div className="flex mb-2">
            <span className="column-header">Summary</span>{" "}
            <span className="font-weight-normal">For </span>
            <span className="column-header">
              {selectFormat("date", data.meta.date, "dddd MMMM Do, YYYY")}
            </span>
          </div>
          <div className="divider-dotted-spaced"></div>
        </div> */}

        {data.metric_preleminary_tad &&
          data.metric_streaming_minutes_per_match &&
          data.metric_preleminary_linear &&
          data.metric_total_streaming_minutes &&
          data.chart && (
            <>
              <div className="row">
                <div className="col-12">
                  <div className="flex">
                    <span>
                      Date:{" "}
                      <span className="column-header">
                        {selectFormat(
                          "date",
                          data.meta.date,
                          "dddd MMMM Do YYYY"
                        )}
                      </span>
                      <span className="mx-2">|</span>
                    </span>

                    <span>
                      Match Day:{" "}
                      <span className="column-header">
                        {data.meta.match_day}
                      </span>{" "}
                      <span className="mx-2">|</span>
                    </span>

                    <span>
                      Games Played:{" "}
                      <span className="column-header">
                        {data.meta.games_played}
                      </span>
                      <span className="mx-2">|</span>
                    </span>

                    {/* <span>
                      Total Games to Date:{" "}
                      <span className="column-header">
                        {data.meta.total_games_to_date}
                      </span>
                    </span> */}
                  </div>
                </div>
                <div className="col-12">
                  <small className="info-format">
                    All values are in Thousands (000)
                  </small>
                </div>
              </div>

              <div className="overflow-auto col-12">
                <div className="mt-4 row">
                  <div className="col-12 col-lg-8">
                    <div className="row">
                      <div className="mb-4 col-6">
                        <Heading size={4}>
                          Preliminary TAD <br /> P2+ AVG Per Match
                        </Heading>
                        <Metric
                          {...data.metric_preleminary_tad}
                          size={"lg"}
                          format="0,0"
                        />
                      </div>

                      <div className="mb-4 col-6">
                        <Heading size={4}>
                          Streaming Minutes Average <br /> Per Match
                        </Heading>
                        <Metric
                          {...data.metric_streaming_minutes_per_match}
                          size={"lg"}
                          format="0,0"
                        />
                      </div>

                      <div className="col-6">
                        <Heading size={4}>
                          Preliminary Linear <br /> Persons 2+
                        </Heading>
                        <Metric
                          {...data.metric_preleminary_linear}
                          size={"lg"}
                          format="0,0"
                        />
                      </div>

                      <div className="col-6">
                        <Heading size={4}>
                          Total Streaming Minutes <br />
                          For Yesterday
                        </Heading>
                        <Metric
                          {...data.metric_total_streaming_minutes}
                          size={"lg"}
                          format="0,0"
                          widget__title
                          noselect
                        />
                      </div>
                    </div>
                  </div>

                  <div className="mt-4 col-12 col-lg-4 mt-lg-0">
                    <div className="row">
                      <div className="col-12">
                        <Heading size={4}>
                          Total Streaming Minutes for Yesterday
                        </Heading>
                        <div className="d-flex">
                          <div className="mt-4">
                            <BarChart
                              width={60}
                              height={220}
                              data={data.chart}
                              margin={{
                                top: 0,
                                right: 0,
                                left: 0,
                                bottom: 0,
                              }}
                            >
                              {renderBars(data.chart)}
                            </BarChart>
                          </div>

                          <div className="mt-auto ml-4 mr-4 w-100">
                            {renderMetrics()}

                            {/* <div className="d-flex info-detail-list align-items-center">
                      <div
                        className="info-detail-icon"
                        style={{ backgroundColor: "#5DC5DB" }}
                      ></div>
                      <div className="w-20 mr-auto info-detail info-detail-label">
                        Linear
                      </div>
                      <div className="mr-auto">
                        <Metric {...data.metric_linear_yesterday} size={"xs"} />
                      </div>
                    </div>

                    <div className="d-flex info-detail-list align-items-center">
                      <div
                        className="info-detail-icon"
                        style={{ backgroundColor: "#F5D45A" }}
                      ></div>
                      <div className="w-20 mr-auto info-detail info-detail-label">
                        Peacock
                      </div>
                      <div className="mr-auto">
                         <Metric
                          {...data.metric_peacock_yesterday}
                          size={"xs"}
                        /> 
                      </div>
                    </div>

                    <div className="d-flex info-detail-list align-items-center">
                      <div
                        className="info-detail-icon"
                        style={{ backgroundColor: "#EB765B" }}
                      ></div>
                      <div className="w-20 mr-auto info-detail info-detail-label">
                        OneApp
                      </div>
                      <div className="mr-auto">
                         <Metric
                          size={"xs"}
                          value={data.metric_one_app_yesterday.value}
                        /> 
                      </div>
                    </div> */}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </>
          )}

        {/* <div className="mt-4 row">
          <div className="col-12 col-lg-8">
            <div className="row">
              <div className="mb-4 col-6">
                <Heading size={4}>
                  Preliminary TAD <br /> P2+ AVG Per Match
                </Heading>
                <Metric
                  {...data.metric_preleminary_tad}
                  size={"lg"}
                  format="0,0"
                />
              </div>

              <div className="mb-4 col-6">
                <Heading size={4}>
                  Streaming Minutes Average <br /> Per Match
                </Heading>
                <Metric
                  {...data.metric_streaming_minutes_per_match}
                  size={"lg"}
                  format="0,0"
                />
              </div>

              <div className="col-6">
                <Heading size={4}>
                  Preliminary Linear <br /> Persons 2+
                </Heading>
                <Metric
                  {...data.metric_preleminary_linear}
                  size={"lg"}
                  format="0,0"
                />
              </div>

              <div className="col-6">
                <Heading size={4}>
                  Total Streaming Minutes <br />
                  For Yesterday
                </Heading>
                <Metric
                  {...data.metric_total_streaming_minutes}
                  size={"lg"}
                  format="0,0"
                  widget__title
                  noselect
                />
              </div>
            </div>
          </div>

          <div className="mt-4 col-12 col-lg-4 mt-lg-0">
            <div className="row">
              <div className="col-12">
                <Heading size={4}>
                  Total Streaming Minutes for Yesterday
                </Heading>
                <div className="d-flex">
                  <div className="mt-4">
                    <BarChart
                      width={60}
                      height={220}
                      data={data.chart}
                      // barCategoryGap={0}
                      // barGap={0}
                      margin={{
                        top: 0,
                        right: 0,
                        left: 0,
                        bottom: 0,
                      }}
                    >
                      <Bar
                        dataKey="a"
                        stackId="yesterday"
                        barSize={30}
                        fill="#EB765B"
                      />
                      <Bar
                        dataKey="b"
                        stackId="yesterday"
                        barSize={30}
                        fill="#F5D45A"
                      />
                      <Bar
                        dataKey="c"
                        stackId="yesterday"
                        barSize={30}
                        fill="#5DC5DB"
                      />

                      <Bar dataKey="a" stackId="prior" fill="#EB765B" />
                      <Bar dataKey="b" stackId="prior" fill="#F5D45A" />
                      <Bar dataKey="c" stackId="prior" fill="#5DC5DB" />
                    </BarChart>
                  </div>

                  <div className="mt-auto ml-4 mr-4 w-100">
                    <div className="py-2 d-flex info-detail-list justify-content-between align-items-center">
                      <div
                        className="info-detail-icon"
                        style={{ width: "75px" }}
                      ></div>
                      <div className="info-detail">Yesterday</div>
                      <div className="ml-4 mr-auto info-detail">Prior Day</div>
                      <div className="info-detail">%</div>
                    </div>
                    <div className="info-detail-list-border"></div>

                    <div className="py-2 d-flex info-detail-list justify-content-between align-items-center">
                      <div
                        className="info-detail-icon"
                        style={{ backgroundColor: "#5DC5DB" }}
                      ></div>
                      <div className="w-20 mr-auto info-detail info-detail-label">
                        Linear
                      </div>
                      <div className="mr-auto">
                        <Metric
                          value={data.metric_linear_yesterday.value}
                          size={"xs"}
                        />
                      </div>
                      <div className="ml-4 mr-auto">
                        <Metric
                          value={data.metric_linear_prior_day.value}
                          size={"xs"}
                        />
                      </div>
                      <div className="ml-auto">
                        <div className="ml-auto info-detail">
                          {renderTrend(data.metric_linear_trend.value)}
                        </div>
                      </div>
                    </div>
                    <div className="info-detail-list-border"></div>

                    <div className="py-2 d-flex info-detail-list justify-content-between align-items-center">
                      <div
                        className="info-detail-icon"
                        style={{ backgroundColor: "#F5D45A" }}
                      ></div>
                      <div className="w-20 mr-auto info-detail info-detail-label">
                        Peacock
                      </div>
                      <div className="mr-auto">
                        <Metric
                          value={data.metric_peacock_yesterday.value}
                          size={"xs"}
                        />
                      </div>
                      <div className="ml-4 mr-auto">
                        <Metric
                          size={"xs"}
                          value={data.metric_peacock_prior_day.value}
                        />
                      </div>
                      <div className="ml-auto">
                        <div className="ml-auto info-detail">
                          {renderTrend(data.metric_peacock_trend.value)}
                        </div>
                      </div>
                    </div>

                    <div className="py-2 d-flex info-detail-list justify-content-between align-items-center">
                      <div
                        className="info-detail-icon"
                        style={{ backgroundColor: "#EB765B" }}
                      ></div>
                      <div className="w-20 mr-auto info-detail info-detail-label">
                        OneApp
                      </div>
                      <div className="mr-auto">
                        <Metric
                          size={"xs"}
                          value={data.metric_one_app_yesterday.value}
                        />
                      </div>
                      <div className="ml-4 mr-auto">
                        <Metric
                          size={"xs"}
                          value={data.metric_one_app_prior_day.value}
                        />
                      </div>
                      <div className="ml-auto info-detail">
                        {renderTrend(data.metric_one_app_trend.value)}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div> */}
      </>
    );
  }
}

export default WorldCupActualRatings;
